// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Zw3W","tab":"Tabs_tab__32k4T","tabActive":"Tabs_tabActive__3opE8"};